import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/preset.css";
import toast from "./plugins/toast";
import loading from "./plugins/loading";
import waterfall from 'vue-waterfall2';
import { Toast } from "vant";

Vue.use(Toast);
Vue.use(waterfall);
Vue.use(toast);
Vue.use(loading);

Vue.config.productionTip = false;

console.log("v1.0.0");

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
